<template>
  <div class="header-itens__lang">
    <div class="header-itens__lang-menu">
      <p>{{ langActive }}</p>
      <IconArrowDown />
    </div>
    <div class="header-itens__lang-options">
      <template v-for="(language, index) in lang">
        <a
          @click="handleClickLang(language)"
          v-if="language !== langActive"
          :key="index"
        >
          <span>{{ language }}</span>
          <template v-if="language === 'pt-pt'">
            - Português
            <img
              class="img-fluid"
              src="@/assets/img/image-bandeira-portugal.jpg"
              alt="imagem bandeira portugal"
              title="imagem bandeira portugal"
            />
          </template>
          <template v-else>
            - English
            <img
              class="img-fluid"
              src="@/assets/img/image-bandeira-reino-unido.jpg"
              alt="imagem bandeira reino unido"
              title="imagem bandeira reino unido"
            />
          </template>
        </a>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import IconArrowDown from "@/components/icons/IconArrowDown.vue";

export default {
  components: {
    IconArrowDown,
  },
  computed: {
    ...mapGetters(["lang", "langActive"]),
  },
  methods: {
    ...mapActions(["setLangActive"]),
    handleClickLang(lang) {
      this.setLangActive(lang);
      location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.header-itens__lang {
  position: relative;
  width: 100px;
  height: 40px;
  background: var(--color-white);
  border: 1px solid var(--color-gray);
  border-radius: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover,
  &:focus {
    .header-itens__lang-menu {
      p {
        color: var(--color-gray);
      }
      svg {
        fill: var(--color-gray);
      }
    }
    .header-itens__lang-options {
      opacity: 1;
      pointer-events: initial;
    }
  }
  @media (max-width: 991px) {
    width: 35px;
    height: 35px;
  }
  &-menu {
    display: flex;
    align-items: center;
    gap: 10px;
    p {
      font-size: 15px;
      font-family: "Font Regular";
      color: var(--color-black);
      text-transform: uppercase;
      margin-bottom: 0;
      transition: 500ms;
      @media (max-width: 991px) {
        font-size: 10px;
      }
    }
    svg {
      transition: 500ms;
      @media (max-width: 991px) {
        display: none;
      }
    }
  }
  &-options {
    position: absolute;
    top: 100%;
    right: 0;
    width: 210px;
    background: var(--color-white);
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
    border-radius: 10px;
    opacity: 0;
    pointer-events: none;
    a {
      display: flex;
      justify-content: center;
      padding: 12.5px 20px;
      font-size: 16px;
      font-family: "Font Regular";
      color: var(--color-green) !important;
      transition: 500ms;
      &:hover,
      &:focus {
        cursor: pointer;
        opacity: 0.8;
      }
      span {
        text-transform: uppercase;
        margin-right: 5px;
      }
      img {
        margin-left: 10px;
      }
    }
  }
}
</style>
